module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/first.js
// module id = 560
// module chunks = 0